import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader } from 'lucide-react';
import { getUserRolesFromToken, isPlatformAdmin } from '../utils/roleAccess';

/** Guards the /supperadmin portal — only the global platform owner may enter. */
export const SuperAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <Loader className="h-8 w-8 animate-spin text-white" />
      </div>
    );
  }

  if (!user || !isPlatformAdmin(getUserRolesFromToken())) {
    return <Navigate to="/supperadmin/login" replace />;
  }

  return <>{children}</>;
};
